import React from 'react';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import { Provider as StoreProvider } from 'react-redux';
import { ConnectedRouter } from "connected-react-router";
import CssBaseline from "@material-ui/core/CssBaseline";
import { ThemeProvider } from "@material-ui/core/styles";
import { theme } from "./theme";
import ScrollReset from "./components/ScrollReset";
import AppLoader from "./components/AppLoader";
import AppNotifier from "./components/AppNotifier";
import { SnackbarProvider } from 'notistack';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
export const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
export const store = configureStore(history);

export default () => {
  return(
  <StoreProvider store={store}>
    <CssBaseline />
    <ThemeProvider theme={theme} >
      <ConnectedRouter history={history}>

        <SnackbarProvider maxSnack={3}>
          <AppNotifier />
          <ScrollReset />
          <AppLoader />
        </SnackbarProvider>

      </ConnectedRouter>
    </ThemeProvider>
  </StoreProvider>
);
};

